import { render, staticRenderFns } from "./IconSvgMp4.vue?vue&type=template&id=541575f0&scoped=true&"
import script from "./IconSvgMp4.vue?vue&type=script&lang=js&"
export * from "./IconSvgMp4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541575f0",
  null
  
)

export default component.exports